import React, { useRef } from 'react'
import { useCart } from '../../hooks/useCart';

// this is a component which takes the values needed for the Recharge line
// item props and creates an add to cart button

interface Props {
  quantity: number
  sellingPlanId: number
  variantId: number
  // shippingIntervalFrequency: number
  // shippingIntervalUnitType: 'month' | 'week' | 'day' 
  numberChargesUntilExpiration?: number
  chargeDelay: number
  className?: null | string
  extraProperties?: Record<string, string>
}

const RechargeAddToCart: React.FunctionComponent<Props> = ({
  children,
  quantity,
  sellingPlanId,
  variantId,
  className,
  extraProperties,
  chargeDelay
}) => {
  const { addSubsProduct } = useCart() 
  const btn = useRef(null) 

  return (
    <button ref={btn} className={ className } type="button" onClick={() => addSubsProduct(btn.current, variantId, quantity, sellingPlanId, {
      //any extra line item props defined:
      ...extraProperties ? extraProperties : {
        _charge_delay: chargeDelay.toString()
      }
    }
    )}>{ children }</button>
      
  )
};

export default RechargeAddToCart